import React from "react";
import { connect } from "react-redux";
import * as actions from "Actions";
import { CreditCards } from "Utils/SvgIcons";
import CreditCardLineItem from "./creditCards/CreditCardLineItem";
import CreditCardForm from "./creditCards/CreditCardForm";
import WorldpayHostedPaymentModal from "./creditCards/WorldpayHostedPaymentModal";
import StripeSecureCardModal from "./creditCards/StripeSecureCardModal";
import LoadingSpinner from "Utils/LoadingSpinner";
import converter from "json-style-converter/es5";

// Fetch profile info from Redux customer, then display it.

class ProfilePaymentMethods extends React.Component {
  state = {
    initialBillingAddress: null,
    worldpayModalOpen: false,
    stripeModalOpen: false,
  };

  componentDidMount() {
    const { fetchProfile, location } = this.props; // Redux
    fetchProfile(location.id);
  }

  copyAddress = (event, isChecked) => {
    if (isChecked) {
      const { customer } = this.props;
      const customerAddress = {
        streetAddress1: customer.streetAddress1,
        streetAddress2: customer.streetAddress2,
        city: customer.city,
        postalCode: customer.postalCode,
        locale: customer.locale,
        country: customer.country
      };
      this.setState({
        initialBillingAddress: converter.camelToSnakeCase(customerAddress)
      });
    }
  };

  handleOpenWorldpayModal = () => this.setState({ worldpayModalOpen: true });
  handleCloseWorldpayModal = () => this.setState({ worldpayModalOpen: false });
  handleOpenStripeModal = () => this.setState({ stripeModalOpen: true });
  handleCloseStripeModal = () => this.setState({ stripeModalOpen: false });

  handleWorldpayCardSaved = () => {
    const { fetchProfile, location } = this.props;
    if (fetchProfile) fetchProfile(location.id);
    this.handleCloseWorldpayModal();
  };

  handleStripeCardSaved = () => {
    const { fetchProfile, location } = this.props;
    if (fetchProfile) fetchProfile(location.id);
    this.handleCloseStripeModal();
  };

  render() {
    const { customer, loading, location, submitCreditCard } = this.props;
    const { initialBillingAddress, worldpayModalOpen, stripeModalOpen } = this.state;
    const useWorldpay = ["worldpay", "launchpay"].includes(location.paymentProcessor);
    const useStripe = location.paymentProcessor === "stripe";

    if (loading) {
      return <LoadingSpinner />;
    }
    return (
      <section className="payments">
        <h4>Payment Methods</h4>
        <CreditCards />
        <div>
          {useWorldpay ? (
            <>
              <button type="button" className="btn" onClick={this.handleOpenWorldpayModal} style={{ marginBottom: "15px" }}>
                Add A New Card
              </button>
              <WorldpayHostedPaymentModal
                open={worldpayModalOpen}
                toggle={this.handleCloseWorldpayModal}
                title="Add Credit Card"
                location={location}
                customerId={customer.id}
                customerType="Customer"
                nickname=""
                onCardSaved={this.handleWorldpayCardSaved}
                onError={(error) => console.error("Worldpay error:", error)}
              />
            </>
          ) : useStripe ? (
            <>
              <button type="button" className="btn" onClick={this.handleOpenStripeModal} style={{ marginBottom: "15px" }}>
                Add A New Card
              </button>
              <StripeSecureCardModal
                open={stripeModalOpen}
                toggle={this.handleCloseStripeModal}
                title="Add Credit Card"
                location={location}
                nickname=""
                onCardSaved={this.handleStripeCardSaved}
                onError={(error) => console.error("Stripe error:", error)}
              />
            </>
          ) : (
            <CreditCardForm
              withPaymentType={location.paymentProcessor === "propay"}
              initialBillingAddress={initialBillingAddress}
              hideCopy={customer.streetAddress1 === null}
              type="save-card"
              copyAddress={this.copyAddress}
              onSubmit={(values) => submitCreditCard(values, location.id)}
            />
          )}
          {customer.creditCards && (
            <ul className="itemList">
              {customer.creditCards.filter(card => {
                const loc = location.paymentProcessor;
                const cardProc = card.paymentProcessor;
                if (cardProc === loc) return true;
                if ((loc === "launchpay" && cardProc === "worldpay") || (loc === "worldpay" && cardProc === "launchpay")) return true;
                return false;
              }).map(creditCard => (
                <CreditCardLineItem
                  creditCard={creditCard}
                  key={creditCard.id}
                  locationId={location.id}
                />
              ))}
            </ul>
          )}
        </div>
      </section>
    );
  }
}

const mapStateToProps = state => {
  const { location } = state.locations;
  const { customer, errors, loading } = state.customer;
  return { location, customer, errors, loading };
};

export default connect(mapStateToProps, actions)(ProfilePaymentMethods);
